import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { textStyles } from './commons/textStyles';
export var Paragraph = styled.p.withConfig({
  displayName: "Paragraph",
  componentId: "sc-eygd04-0"
})(["max-width:", ";", ";", ";", ";&:not(:last-child){", ";}"], function (_ref) {
  var maxWidth = _ref.maxWidth;
  return maxWidth ? "".concat(maxWidth) : '666px';
}, function (_ref2) {
  var compact = _ref2.compact;
  return compact ? getFont(1, 'compact') : getFont(1);
}, textStyles, function (_ref3) {
  var center = _ref3.center;
  return center ? "\n    margin-left: auto;\n    margin-right: auto;\n    " : null;
}, function (_ref4) {
  var noPadding = _ref4.noPadding,
    compact = _ref4.compact;
  return !noPadding ? compact ? 'padding-bottom: 24px;' : 'padding-bottom: 27px;' : null;
});
export var ParagraphSmall = styled(Paragraph).withConfig({
  displayName: "Paragraph__ParagraphSmall",
  componentId: "sc-eygd04-1"
})(["", ";&:not(:last-child){", ";}"], function (_ref5) {
  var compact = _ref5.compact;
  return compact ? getFont(0, 'compact') : getFont(0);
}, function (_ref6) {
  var noPadding = _ref6.noPadding,
    compact = _ref6.compact;
  return !noPadding ? compact ? 'padding-bottom: 21px;' : 'padding-bottom: 24px;' : null;
});